export interface IGroupClassification {
	id: string;
	active: boolean;
	name: string;
	companyOwner: string;
}

export class GroupClassification {
	id: string;
	name: string;
	active: boolean;
	status: string;
	classifications: Classification[];
	constructor() {
		this.name = '';
		this.active = true;
		this.classifications = [];
	}
}

export class Classification {
	companyIds: string[];
	departamentIds: string[];
	healthPlansIds: string[];
	localitiesIds: string[];
	roleIds: string[];
	userIds: string[];
	users?: any[];
	id: string;
	companyMasterId: string;
	availableForMinors: boolean;
	availableForDependents: boolean;
}

export enum ConditionsEnum {
	'Grávidas' = 'toPregnant',
	'Diabéticos' = 'toDiabetes',
	'Cardiopatas' = 'toCardiopathy'
}
